
import { verifyAliyunCaptcha } from "@/utils/aliyunCaptcha";
const EMAIL_REG = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const RESEND_COOLDOWN_SEC = 60

export default {
  name: 'AuthForgotPasswordModal',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      resendLoading: false,
      submitSuccess: false,
      resendCountdown: 0,
      resendTimer: null,
      form: {
        email: '',
      },
    }
  },

  computed: {
    rules() {
      return {
        email: [
          { required: true, message: this.$t('page.INPUT_EMAIL'), trigger: 'blur' },
          { pattern: EMAIL_REG, message: this.$t('page.VALID_EMAIL_REQUIRED'), trigger: 'blur' },
        ],
      }
    },
  },

  methods: {
    /* ---- 对外接口 ---- */
    openDialog(email = '') {
      this.clearResendTimer()
      this.resendCountdown = 0
      this.submitSuccess = false
      this.form.email = email
      this.dialogVisible = true
    },

    closeDialog() {
      this.clearResendTimer()
      this.resendCountdown = 0
      this.dialogVisible = false
      this.$nextTick(() => {
        this.$refs.forgotForm && this.$refs.forgotForm.resetFields()
        this.submitSuccess = false
      })
    },

    startResendCountdown() {
      this.clearResendTimer()
      this.resendCountdown = RESEND_COOLDOWN_SEC
      this.resendTimer = setInterval(() => {
        this.resendCountdown -= 1
        if (this.resendCountdown <= 0) {
          this.clearResendTimer()
          this.resendCountdown = 0
        }
      }, 1000)
    },

    clearResendTimer() {
      if (this.resendTimer) {
        clearInterval(this.resendTimer)
        this.resendTimer = null
      }
    },

    async sendPasswordResetWithCaptcha(email) {
      const sceneRes = await this.$global.getSceneId();
      const sceneId = sceneRes?.data?.encrypted_scene_id || sceneRes?.data || "";
      if (!sceneId) {
        this.$message.error(this.$t('page.GET_VERIFICATION_SCENE_FAILED'))
        return { ok: false }
      }
      const captchaResult = await verifyAliyunCaptcha({
        EncryptedSceneId: sceneId,
        language: "en",
      });
      if (!captchaResult) {
        this.$message.error(this.$t('page.VERIFICATION_FAILED'))
        return { ok: false }
      }
      const res = await this.$global.sendPasswordResetEmail({
        email,
        captcha: captchaResult,
      }, {
        jumpUrl: window.location.origin + '/user/gallery',
        lang: this.$i18n.locale || "en",
      })
      const success = res?.code === 1
      if (!success) {
        this.$message.error(res?.msg || this.$t('page.SEND_PASSWORD_RESET_FAILED'))
      }
      return { ok: success, res }
    },

    /* ---- 提交重置密码 ---- */
    async handleSubmit() {
      try {
        this.loading = true
        const { ok } = await this.sendPasswordResetWithCaptcha(this.form.email)
        if (ok) {
          this.submitSuccess = true
          this.startResendCountdown()
        }
      } catch (error) {
        console.error("Send password reset email error:", error)
      } finally {
        this.loading = false
      }
    },

    async handleResendEmail() {
      if (!this.form.email || this.resendCountdown > 0) return
      this.resendLoading = true
      try {
        const { ok } = await this.sendPasswordResetWithCaptcha(this.form.email)
        if (ok) {
          this.$message.success(this.$t('page.EMAIL_SENT'))
          this.startResendCountdown()
        }
      } catch (error) {
        console.error("resend password reset email error:", error)
        this.$message.error(error?.message || this.$t('page.SYSTEM_ERROR'))
      } finally {
        this.resendLoading = false
      }
    },

    /* ---- 返回登录弹窗 ---- */
    backToLogin() {
      const email = this.form.email
      this.closeDialog()
      this.$emit('open-login', email)
    },
  },
  beforeDestroy() {
    this.clearResendTimer()
  }
}
